import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    brand: {
      100: "#C7D2FE",
      200: "#A5B4FC",
      300: "#818CF8",
      400: "#818CF8",
      500: "#6366F1",
      600: "#4F46E5",
      700: "#4338CA",
      800: "#3730A3",
      900: "#312E81",
    },
    brandScheme: {
      100: "#C7D2FE",
      200: "#A5B4FC",
      300: "#818CF8",
      400: "#818CF8",
      500: "#6366F1",
      600: "#4F46E5",
      700: "#4338CA",
      800: "#3730A3",
      900: "#312E81",
    },
    brandTabs: {
      100: "#C7D2FE",
      200: "#A5B4FC",
      300: "#818CF8",
      400: "#818CF8",
      500: "#6366F1",
      600: "#4F46E5",
      700: "#4338CA",
      800: "#3730A3",
      900: "#312E81",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEE2E2",
      500: "#EF4444",
      600: "#DC2626",
      700: "#B91C1C",
    },
    blue: {
      50: "#EFF6FF",
      500: "#3B82F6",
    },
    orange: {
      100: "#FFEDD5",
      500: "#F97316",
    },
    green: {
      100: "#D1FAE5",
      500: "#10B981",
      600: "#059669",
      700: "#047857",
    },
    purple: {
      500: "#8B5CF6",
      600: "#7C3AED",
      700: "#6D28D9",
    },
    navy: {
      50: "#F9FAFB",
      100: "#E5E7EB",
      200: "#D1D5DB",
      300: "#9CA3AF",
      400: "#6B7280",
      500: "#4B5563",
      600: "#374151",
      700: "#1F2937",
      800: "#111827",
      900: "#030712",
    },
    gray: {
      50: "#F9FAFB",
      100: "#F9FAFB",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
      950: "#030712",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
